'use strict';

var _slicedToArray = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var CID = require('cids');

var log = require('debug')('ipfs:mfs:utils:with-mfs-root');

var waterfall = require('async/waterfall');

var _require = require('./constants'),
    MFS_ROOT_KEY = _require.MFS_ROOT_KEY;

var withMfsRoot = function withMfsRoot(ipfs, callback) {
  var repo = ipfs._repo;
  var datastore = repo && repo.datastore;

  if (!repo || !datastore) {
    return callback(new Error('Please run jsipfs init first'));
  }

  waterfall([// Open the repo if it's been closed
  function (cb) {
    return datastore.open(function (error) {
      return cb(error);
    });
  }, function (cb) {
    // Load the MFS root CID
    datastore.get(MFS_ROOT_KEY, function (error, result) {
      // Once datastore-level releases its error.code addition, we can remove error.notFound logic
      if (error && (error.notFound || error.code === 'ERR_NOT_FOUND')) {
        log('Creating new MFS root');
        return waterfall([// Store an empty node as the root
        function (next) {
          return ipfs.files.add({
            path: '/'
          }, next);
        }, // Turn the hash into a Buffer
        function (_ref, next) {
          var _ref2 = _slicedToArray(_ref, 1),
              hash = _ref2[0].hash;

          return next(null, new CID(hash));
        }, function (cid, next) {
          return repo.closed ? datastore.open(function (error) {
            return next(error, cid);
          }) : next(null, cid);
        }, // Store the Buffer in the datastore
        function (cid, next) {
          return datastore.put(MFS_ROOT_KEY, cid.buffer, function (error) {
            return next(error, cid);
          });
        }], cb);
      }

      var cid = result ? new CID(result) : null;
      cb(error, cid);
    });
  }, // Turn the Buffer into a CID
  function (cid, cb) {
    log("Fetched MFS root ".concat(cid.toBaseEncodedString()));
    cb(null, cid);
  } // Invoke the API function with the root CID
  ], callback);
};

module.exports = withMfsRoot;